import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { initializeDeepLinks } from "@/lib/nativeDeepLinks";
import { initializeNative } from "@/lib/nativeBoot";
import { initializeRealtimeReconnect } from "@/lib/realtimeReconnect";

void initializeNative();
void initializeDeepLinks();
void initializeRealtimeReconnect();

createRoot(document.getElementById("root")!).render(<App />);
